<template>
  <div class="service-view">
    <LoadingWidget v-if="loading" />

    <transition name="fade">
      <PageTemplate
        v-if="item.title && !loading"
        class="item"
        :title="item.title"
      >
        <div class="pt-10 pt-md-14 pt-lg-16">
          <v-sheet
            :width="smAndDown ? '100%' : '50%'"
            class="float-md-left pr-md-7 py-md-10"
          >
            <GallerySlidesWidget v-if="images.length" :images="images" />
          </v-sheet>

          <div class="pt-10">
            <div class="text-center">
              <ButtonWidget @click="scrollTo($refs.team)">
                Faça sua Reserva
              </ButtonWidget>
            </div>

            <div class="pt-12 pt-md-7 ck-content" v-html="item.text"></div>
          </div>
        </div>

        <div ref="team">
          <TeamSection title="Fale com um Consultor" />
        </div>
      </PageTemplate>
    </transition>
  </div>
</template>

<script>
import LoadingWidget from "../components/widgets/LoadingWidget.vue";
import PageTemplate from "../components/templates/PageTemplate.vue";
import GallerySlidesWidget from "../components/widgets/GallerySlidesWidget.vue";
import ButtonWidget from "../components/widgets/ButtonWidget.vue";
import TeamSection from "../components/sections/TeamSection.vue";
import { scrollTo } from "../utils/scrollTo";

const _config = {
  mod: "services",
};

export default {
  data: () => ({
    loading: true,
    item: {},
    images: [],
  }),
  computed: {
    itemId() {
      return parseFloat(this.$route.params.item.replace(/^.*-([0-9]+)$/, "$1"));
    },
    smAndDown() {
      return this.$vuetify.breakpoint.smAndDown;
    },
  },
  created() {
    this.get();
  },
  methods: {
    get() {
      this.loading = true;

      this.$rest(_config.mod)
        .get({
          id: this.itemId,
        })
        .then((data) => {
          this.item = data;

          const images = [];

          if (data.img && data.img.list)
            data.img.list.map(({ path }) => {
              images.push(this.files + path);
            });

          this.images = images;
        })
        .then(() => (this.loading = false));
    },
    scrollTo,
  },
  watch: {
    itemId() {
      this.get();
    },
    $route() {
      this.get();
    },
  },
  components: {
    LoadingWidget,
    PageTemplate,
    GallerySlidesWidget,
    ButtonWidget,
    TeamSection,
  },
};
</script>

<style lang="scss" scoped>
.service-view::v-deep {
  .title-widget {
    &:before,
    &:after {
      background-color: var(--v-primary-lighten4);
    }
  }
}
</style>
